/* ToysWoys concept B: deliver-to PIN note, product rails (arrows), AJAX add to cart, back to top. No dependencies. */
(function () {
  var KEY = 'tw_pin';
  function getPin() { try { return localStorage.getItem(KEY) || ''; } catch (e) { return ''; } }
  function setPin(v) { try { v ? localStorage.setItem(KEY, v) : localStorage.removeItem(KEY); } catch (e) {} }
  function paintPins() {
    var pin = getPin();
    document.querySelectorAll('[data-pin-label]').forEach(function (el) { el.textContent = pin ? pin : 'Enter PIN code'; });
    document.querySelectorAll('[data-pin-clear]').forEach(function (el) { el.hidden = !pin; });
  }
  if (!customElements.get('tw-pin')) {
    customElements.define('tw-pin', class extends HTMLElement {
      connectedCallback() {
        var self = this, btn = this.querySelector('[data-pin-toggle]'), pop = this.querySelector('.twb-pin__pop');
        var form = this.querySelector('[data-pin-form]'), input = this.querySelector('[data-pin-input]'), err = this.querySelector('[data-pin-err]');
        if (!btn || !pop) return;
        function close() { pop.hidden = true; btn.setAttribute('aria-expanded', 'false'); }
        function open() { pop.hidden = false; btn.setAttribute('aria-expanded', 'true'); input.value = getPin(); err.hidden = true; setTimeout(function () { input.focus(); }, 30); }
        btn.addEventListener('click', function (e) { e.preventDefault(); pop.hidden ? open() : close(); });
        input.addEventListener('input', function () { input.value = input.value.replace(/\D/g, '').slice(0, 6); });
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var v = input.value.trim();
          if (!/^[1-9][0-9]{5}$/.test(v)) { err.hidden = false; input.focus(); return; }
          setPin(v); paintPins(); close(); btn.focus();
        });
        this.querySelector('[data-pin-clear]').addEventListener('click', function () { setPin(''); paintPins(); input.value = ''; input.focus(); });
        document.addEventListener('click', function (e) { if (!self.contains(e.target)) close(); });
        this.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); btn.focus(); } });
        paintPins();
      }
    });
  }
  /* rails: arrow buttons scroll the track by ~one viewport of cards */
  function initRails(root) {
    (root || document).querySelectorAll('[data-twb-rail]').forEach(function (rail) {
      if (rail.dataset.ready) return; rail.dataset.ready = '1';
      var track = rail.querySelector('[data-twb-track]'), prev = rail.querySelector('[data-twb-prev]'), next = rail.querySelector('[data-twb-next]');
      if (!track) return;
      function upd() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.hidden = track.scrollLeft <= 2;
        if (next) next.hidden = track.scrollLeft >= max;
      }
      function go(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: 'smooth' }); }
      prev && prev.addEventListener('click', function () { go(-1); });
      next && next.addEventListener('click', function () { go(1); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
      window.addEventListener('resize', upd); upd();
    });
  }
  /* add to cart from B cards: AJAX, then refresh the header cart bubble; falls back to normal form post */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('form[data-twb-atc]') || !window.fetch) return;
    e.preventDefault();
    var b = f.querySelector('button[type=submit]'), label = b ? b.innerHTML : '';
    if (b) { b.disabled = true; b.textContent = 'Adding…'; }
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(f) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        if (b) { b.textContent = 'Added ✓'; }
        return fetch(root + '?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (j) {
          var html = j && j['cart-icon-bubble']; if (!html) return;
          var d = new DOMParser().parseFromString(html, 'text/html'), fresh = d.getElementById('cart-icon-bubble');
          if (fresh) document.querySelectorAll('#cart-icon-bubble').forEach(function (el) { el.innerHTML = fresh.innerHTML; });
        });
      })
      .catch(function () { if (b) b.textContent = 'Could not add'; })
      .finally(function () { setTimeout(function () { if (b) { b.disabled = false; b.innerHTML = label; } }, 1800); });
  });
  /* back to top */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-twb-top]');
    if (!t) return; e.preventDefault();
    window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });
  function boot() { initRails(); paintPins(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { initRails(e.target); paintPins(); });
})();

/* Concept B department nav: aria-expanded sync, Escape to close, All button toggle */
if (!customElements.get('tw-b-nav')) {
  customElements.define('tw-b-nav', class extends HTMLElement {
    connectedCallback() {
      if (this._init) return; this._init = true;
      const items = this.querySelectorAll('.twb-nav__item--has, .twb-nav__item--all');
      const setExp = (li, v) => { const t = li.querySelector(':scope > .twb-nav__link'); if (t) t.setAttribute('aria-expanded', v ? 'true' : 'false'); };
      items.forEach(li => {
        li.addEventListener('mouseenter', () => { li.classList.remove('is-closed'); setExp(li, true); });
        li.addEventListener('mouseleave', () => { li.classList.remove('is-closed'); if (!li.classList.contains('is-open')) setExp(li, false); });
        li.addEventListener('focusin', () => { li.classList.remove('is-closed'); setExp(li, true); });
        li.addEventListener('focusout', e => { if (!li.contains(e.relatedTarget)) { li.classList.remove('is-open', 'is-closed'); setExp(li, false); } });
        li.addEventListener('keydown', e => {
          if (e.key === 'Escape') { li.classList.remove('is-open'); li.classList.add('is-closed'); setExp(li, false); const t = li.querySelector(':scope > .twb-nav__link'); t && t.focus(); li.classList.add('is-closed'); }
        });
      });
      const btn = this.querySelector('.twb-nav__btn');
      if (btn) btn.addEventListener('click', e => { e.preventDefault(); const li = btn.parentElement; const o = !li.classList.contains('is-open'); li.classList.toggle('is-open', o); li.classList.toggle('is-closed', !o); setExp(li, o); });
      document.addEventListener('click', e => { if (!this.contains(e.target)) this.querySelectorAll('.is-open').forEach(li => { li.classList.remove('is-open'); setExp(li, false); }); });
    }
  });
}
